// Create a component that appears the first time a user sees their completed song
// This will help them understand how to download it

// Create a new file: components/FirstSongModal.js
import React from 'react';
import styles from '../styles/FirstSongModal.module.css';

const FirstSongModal = ({ isVisible, onClose, onShowDownloadHelp }) => {
  if (!isVisible) return null;

  return (
    <div className={styles.firstSongOverlay}>
      <div className={styles.firstSongContent}>
        <button className={styles.closeButton} onClick={onClose}>×</button>
        
        <div className={styles.modalHeader}>
          <div className={styles.celebrationIcon}>🎉</div>
          <h2 className={styles.modalTitle}>Your Song is Ready!</h2>
        </div>
        
        <p className={styles.congratsText}>
          Congratulations! Your custom song has been created and is ready for you to enjoy.
        </p>
        
        <div className={styles.instructionSection}>
          <h3>Here's how to enjoy your song:</h3>
          
          <div className={styles.instructionItem}>
            <div className={styles.instructionIcon}>▶️</div>
            <div className={styles.instructionText}>
              <strong>Listen to your song</strong> by clicking the purple play button.
            </div>
          </div>
          
          <div className={styles.instructionItem}>
            <div className={styles.instructionIcon}>💾</div>
            <div className={styles.instructionText}>
              <strong>Download your song</strong> to keep it forever by clicking "Download MP3".
              <p className={styles.downloadTip}>
                <strong>Tip for desktop users:</strong> Right-click on "Download MP3" and select "Save link as..." 
              </p>
              <button 
                className={styles.helpButton}
                onClick={() => {
                  onClose();
                  onShowDownloadHelp();
                }}
              >
                Need help downloading? Click here
              </button>
            </div>
          </div>
          
          <div className={styles.instructionItem}>
            <div className={styles.instructionIcon}>🎵</div>
            <div className={styles.instructionText}>
              <strong>View the lyrics</strong> by clicking the "View Lyrics" button.
            </div>
          </div>
        </div>
        
        <div className={styles.modalFooter}>
          <button className={styles.gotItButton} onClick={onClose}>Got it, thanks!</button>
        </div>
      </div>
    </div>
  );
};

export default FirstSongModal;